import {AuthGuard} from '../../shared/guards/AuthGuard';
import {ListagemUsuariosPresentation} from './components/ListagemUsuariosPresentation';
import {Sidebar} from '../../shared/components';

export const ListagemUsuariosPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ListagemUsuariosPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};